module.exports = __webpack_public_path__ + "static/logo-ministerija-0d66e0a37fa7cd11475f837dece57b4f.svg";